import { render, staticRenderFns } from "./DashboardLabNonStatus.vue?vue&type=template&id=01c7d25a&scoped=true"
import script from "./DashboardLabNonStatus.vue?vue&type=script&lang=js"
export * from "./DashboardLabNonStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c7d25a",
  null
  
)

export default component.exports